import ReadOnlyInputWithEditLink from './ReadOnlyInputWithEditLink';
export default ReadOnlyInputWithEditLink;